<template>
  <div class="aone-table-search">
    <div class="aone-table-search-input-wrapper">
      <span class="magnifying-glass"></span>
      <input
        class="aone-table-search-input"
        type="text"
        ref="searchBox"
        :placeholder="placeholder"
        @input="updateValue($event.target.value)"
        @keyup.enter="entered($event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "search-small",
  props: ["placeholder", "resetValue"],
  watch: { 
    resetValue: function(value) {
          if(value) {
            this.$refs.searchBox.value = "";
            
          }
      }
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
      this.$emit("on-keyup", value);
    },
    entered(value) {
      this.$emit("on-enter", value);
    },
  },
};
</script>

<style scoped>
/* search bar styling */
.aone-table-search {
  border-radius: 13px !important;
  padding: 4px;
  background: #fff;
  max-width: 400px !important;
  border: 1px solid rgba(136, 136, 136, 1);
}
.aone-table-search-input {
  width: 100%;
  height: 32px;
  line-height: 1;
  display: block;
  font-size: 16px;
  font-weight: normal;
  padding: 6px 12px;
  color: #000;
  border-radius: 4px;
  box-sizing: border-box;
  background-image: none;
  background-color: #fff;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: none !important;
}
.aone-table-search-input:focus-visible {
  outline: none;
}
.aone-table-search ::placeholder {
  color: #ccc;
}
.aone-table-search-input-wrapper {
  position: relative;
  padding-left: 30px;
}
.aone-table-search .magnifying-glass {
  background-image: url(../../../src/assets/image/homebase/search/icon_search.svg) !important;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  margin-left: 8px;
  display: block;
  margin-top: 6px !important;
  width: 35px;
  border: 0px !important;
  height: 35px;
  border-radius: unset !important;
  position: absolute;
  left: 0;
  max-width: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/SearchSmall.vue